var prefix = 'formfield';
export var dataHooks = {
  suffix: "".concat(prefix, "-suffix"),
  labelIndicators: "".concat(prefix, "-indicators"),
  counter: "".concat(prefix, "-counter"),
  children: "".concat(prefix, "-children"),
  label: "".concat(prefix, "-label"),
  asterisk: "".concat(prefix, "-asterisk")
};